import { useVuelidate, type ValidationArgs } from '@vuelidate/core';
import { computed } from 'vue';
import _ from '@/setup/lodash';

interface UseValidateParams<T extends object> {
  rules: ValidationArgs;
  form: T;
}

export function useValidate<T extends object>(params: UseValidateParams<T>) {
  const { rules, form } = params;
  const v$ = useVuelidate(rules, form);

  const isInvalidForm = computed(() => {
    return v$.value.$invalid;
  });

  const checkField = (fieldName: string)  => {
    const current = _.get(v$.value, fieldName);
    current?.$validate?.();
  }

  const isInvalidField = (fieldName: string)  => {
    const current = _.get(v$.value, fieldName);
    return current?.$error || false;
  }

  return { checkField, isInvalidField, isInvalidForm };
}
